import styled from 'styled-components';
import primitives from '@veneer/primitives';
import Images from '../../assets/images';

// import { mixins } from '@jarvis/react-portal-addons';
// Design has DIFFERENT breakpoints!
// 380px: mobile
// 500px
// 740px
// 1024px
// 1280px
// 1440px
// 1900px +

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const DownloadBarContainer = styled.div`
  background-color: ${primitives.color.electricBlue1}; // #c9e0fc;
  display: flex;
  flex-direction: row;
  gap: 12px;
  padding: 8px 20px;
  align-items: center;
  justify-content: space-between;
`;

export const DownloadLink = styled.a`
  text-decoration: underline;
  color: ${primitives.color.gray12}!important; // #1a1a1a;
  min-width: 82px;
`;

export const DownloadLeftContent = styled.div`
  gap: 12px;
  display: flex;
  align-items: center;
  svg {
    min-width: 20px;
  }
`;

export const DownloadText = styled.span`
  color: ${primitives.color.gray12}; // #1a1a1a;
`;

export const LandingPageContainer = styled.div`
  height: 100%;
  background-image: url(${Images.landingPageBackground});
  background-repeat: no-repeat;
  background-size: contain;
  @media (min-width: 1990px) {
    background-position-x: 740px;
  }
  // 1440, 1280, 1024, 740
  background-position-x: 620px;
  background-position-y: 0px;
  @media (max-width: 500px) {
    background: none;
    height: auto;
  }
`;

export const ContentContainer = styled.div`
  width: 100%;
  height: 700px;
  min-height: 700px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  @media (min-width: 1990px) {
    max-width: 740px;
    padding: 80px 40px 80px 80px;
    justify-content: center;
  }
  // 1440
  max-width: 620px;
  padding: 130px 0 0 104px;
  @media (max-width: 1280px) {
    padding: 110px 40px 0 80px;
  }
  @media (max-width: 500px) {
    max-width: 100%;
    padding: 40px 32px 0;
    height: auto;
    min-height: auto;
  }
`;

export const Title = styled.h3`
  color: ${primitives.color.gray12}; // ${({ theme }) => theme.color.foreground.default}; // #1a1a1a;
  padding-bottom: 8px;
`;

export const Body = styled.div`
  color: ${primitives.color.gray9}; // ${({ theme }) => theme.color.foreground.medium}; // #3d3d3d;
  padding-bottom: 32px;
`;

export const Item = styled.div`
  display: flex;
  flex-direction: row;
  padding-bottom: 24px;
  padding-right: 88px;
  gap: 16px;
  @media (max-width: 500px) {
    padding-right: 0;
  }
`;

export const ItemLeftContent = styled.div`
  img, svg {
    min-width: 28px;
    width: 28px;
    margin: 6px;
  }
`;

export const ItemRightContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-top: 5px;
`;

export const ItemTitle = styled.h6`
  color: ${primitives.color.gray12}; // ${({ theme }) => theme.color.foreground.default}; // #1a1a1a;
`;

export const ItemBody = styled.div`
  color: ${primitives.color.gray9}; // ${({ theme }) => theme.color.foreground.default}; // #3d3d3d;
`;
